import styled from 'styled-components'

export const Countdown = styled.div`
  --size: 3rem;
  --thickness: 3px;
  --value: 0;
  --color: #f71963;

  position: relative;
  width: var(--size);
  height: var(--size);
  background: conic-gradient(
    var(--color) calc(var(--value) * 1%),
    #e6e6e6 0deg
  );
  border-radius: 50%;

  &::before {
    content: '';
    position: absolute;
    top: var(--thickness);
    left: var(--thickness);
    width: calc(100% - var(--thickness) * 2);
    height: calc(100% - var(--thickness) * 2);
    background: white;
    border-radius: 50%;
  }

  &::after {
    content: var(--value);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: calc(var(--size) / 4);
    font-weight: bold;
    color: #333;
  }
`
